'use strict';

exports.__esModule = true;
exports.Footer = exports.Textarea = exports.Container = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  border-radius: 4px;\n  border: solid 1px ', ';\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n'], ['\n  border-radius: 4px;\n  border: solid 1px ', ';\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  border: none;\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 1.25;\n  min-height: 130px;\n  padding: 16px;\n  resize: none;\n\n  &::placeholder {\n    color: ', ';\n    opacity: 0.5;\n  }\n\n  &:focus {\n    outline: none;\n  }\n'], ['\n  border: none;\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 1.25;\n  min-height: 130px;\n  padding: 16px;\n  resize: none;\n\n  &::placeholder {\n    color: ', ';\n    opacity: 0.5;\n  }\n\n  &:focus {\n    outline: none;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  border-top: solid 1px ', ';\n  padding: 10px 16px;\n'], ['\n  border-top: solid 1px ', ';\n  padding: 10px 16px;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = exports.Container = _styledComponents2.default.div(_templateObject, function (props) {
  return props.theme.greyLight;
});

var Textarea = exports.Textarea = _styledComponents2.default.textarea(_templateObject2, function (props) {
  return props.theme.navy;
});

var Footer = exports.Footer = _styledComponents2.default.div(_templateObject3, function (props) {
  return props.theme.greyLight;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/qu-react-sdk/lib/components/qu-textarea/style.js
// module id = 1213
// module chunks = 0